import _, {
  forEach, values, keyBy, set,
} from 'lodash';
import {
  FETCH_ALL_COIN_SUCCEED,
  FETCH_COIN_SETTING_SUCCEED,
  FETCH_CRYPTO_LIMIT_WITHDRAWAL_SUCCEED,
  FETCH_INFO_ERC20_SUCCESS,
  FETCH_TOMO_INFO_ERC20_SUCCESS,
  FETCH_LIMIT_WITHDRAWAL_SUCCEED,
  FETCH_MARKET,
  FETCH_MARKET_FAILED,
  FETCH_MARKET_SUCCEED,
  SEARCH_COIN,
  POST_COIN_SETTING_SUCCEED,
  SELECT_COIN,
  FETCH_CRYPTO_EXCHANGE_CONFIG_SUCCEED,
  FETCH_CRYPTO_EXCHANGE_CONFIG_FAILED,
  FETCH_LIST_PUBLIC_KEY_ACTIVE_LIST_CRYPTO_FAILED,
  FETCH_LIST_PUBLIC_KEY_ACTIVE_LIST_CRYPTO_SUCCEED,
  DELETE_PUBLIC_KEY_ACTIVE_LIST_CRYPTO_FAILED,
  DELETE_PUBLIC_KEY_ACTIVE_LIST_CRYPTO_SUCCEED,
  ADD_PUBLIC_KEY_TO_ACTIVE_LIST_CRYPTO_FAILED,
  ADD_PUBLIC_KEY_TO_ACTIVE_LIST_CRYPTO_SUCCEED,
  UPDATE_CRYPTO_EXCHANGE_CONFIG_FAILED, UPDATE_CRYPTO_EXCHANGE_CONFIG_SUCCEED,
} from '../actions/setting_data/action_types';
import utils from '../../common/utils';
import { FETCH_LIMIT_WITHDRAWAL_OF_ADMIN_SUCCEED } from '../actions/admin/action_types';

export default (state = {
  coinSettings: [],
  currencyMarkets: {},
  mapCurrencyMarkets: {},
  coins: [],
  arrCoins: [],
  limitWithdrawals: [],
  objCoinSettings: {},
  dataTableCoin: [],
  selectionCoin: [],
  erc20TokenInfo: {},
  erc20TomoTokenInfo: {},
  mapLimitWithdrawals: {},
  cryptoLimitWithdrawal: [],
  cryptoSettings: [],
  publicKeys: [],
}, action) => {
  switch (action.type) {
    case FETCH_COIN_SETTING_SUCCEED:
      window._.forEach(action.params.data, (item) => {
        item.pair = `${item.coin}/${item.currency}`;
        item.fee = utils.formatCurrency(item.fee);
        item.minimum_amount = utils.formatCurrency(item.minimum_amount);
        item.minimum_quantity = utils.formatCurrency(item.minimum_quantity);
        item.precision = (utils.formatCurrency(item.precision).match(new RegExp('0', 'g')) || []).length;
        item.minimum_quantity_precision = (utils.formatCurrency(item.minimum_quantity_precision).match(new RegExp('0', 'g')) || []).length;
        item.minimum_amount_precision = (utils.formatCurrency(item.minimum_amount_precision).match(new RegExp('0', 'g')) || []).length;
      });
      const objCoinSettings = window._.reduce(action.params.data, (result, item, index) => {
        result[item.pair] = item;
        result[item.pair].key = index;
        return result;
      }, {});
      return {
        ...state,
        coinSettings: action.params.data,
        objCoinSettings,
      };

    case FETCH_ALL_COIN_SUCCEED:
      const coins = window._.reduce(action.params.data, (result, item, index) => {
        result[item.coin] = item;
        result[item.coin].key = index;
        return result;
      }, {});
      return {
        ...state,
        coins,
        arrCoins: _.values(coins),
        selectionCoin: _.values(coins),
      };

    case FETCH_MARKET:
      return {
        ...state,
      };
    case FETCH_MARKET_SUCCEED:
      const mapCurrencyMarkets = {};
      const currencyMarkets = window._.reduce(action.params.data, (result, item, market) => {
        const pair = `${market}`.split(':');
        const coin = pair[0];
        const currency = pair[1];

        if (window._.isEmpty(result[currency])) {
          result[currency] = [];
        }

        item.coin = coin;
        item.currency = currency;
        result[currency].push(item);
        set(mapCurrencyMarkets, `${currency}.${coin}`, item);
        return result;
      }, {});

      return {
        ...state,
        currencyMarkets,
        mapCurrencyMarkets,
      };
    case FETCH_MARKET_FAILED:
      return {
        ...state,
      };
    case FETCH_CRYPTO_LIMIT_WITHDRAWAL_SUCCEED:
      return {
        ...state,
        cryptoLimitWithdrawal: keyBy(action.data, ({ currency, security_level }) => `${currency}:${security_level}`),
      };
    case FETCH_LIMIT_WITHDRAWAL_SUCCEED:
    case FETCH_LIMIT_WITHDRAWAL_OF_ADMIN_SUCCEED:
      const limitWithdrawals = action.coins;

      forEach(action.data, (limit) => {
        limitWithdrawals[limit.currency] = {
          ...limitWithdrawals[limit.currency],
          ...limit,
        };
      });
      return {
        ...state,
        limitWithdrawals: values(limitWithdrawals),
        mapLimitWithdrawals: limitWithdrawals,
      };
    case SELECT_COIN:
      let selectionCoinFake = state.arrCoins.slice();
      if (action.params.coin !== '') {
        selectionCoinFake = _.remove(selectionCoinFake, (n) => n.coin === action.params.coin);
      }
      return {
        ...state,
        selectionCoin: selectionCoinFake,
      };
    case SEARCH_COIN:
      let searchCoin = state.arrCoins.slice();
      if (action.params.coin !== '') {
        searchCoin = _.remove(searchCoin, (n) => { if (n.coin.indexOf(action.params.coin) === 0) { return true; } return false; });
      }
      return {
        ...state,
        selectionCoin: searchCoin,
      };
    case FETCH_INFO_ERC20_SUCCESS:
      return {
        ...state,
        erc20TokenInfo: action.data,
      };
    case FETCH_TOMO_INFO_ERC20_SUCCESS:
      return {
        ...state,
        erc20TomoTokenInfo: action.data,
      };
    case POST_COIN_SETTING_SUCCEED:
      return {
        ...state,
      };
    case FETCH_CRYPTO_EXCHANGE_CONFIG_FAILED:
      return {
        ...state,
      };
    case FETCH_CRYPTO_EXCHANGE_CONFIG_SUCCEED:
      return {
        ...state,
        cryptoSettings: action.params,
      };
    case UPDATE_CRYPTO_EXCHANGE_CONFIG_FAILED:
      return {
        ...state,
      };
    case UPDATE_CRYPTO_EXCHANGE_CONFIG_SUCCEED:
      return {
        ...state,
      };
    case FETCH_LIST_PUBLIC_KEY_ACTIVE_LIST_CRYPTO_FAILED:
      return {
        ...state,
      };
    case FETCH_LIST_PUBLIC_KEY_ACTIVE_LIST_CRYPTO_SUCCEED:
      return {
        ...state,
        publicKeys: _.concat(state.publicKeys, action.data),
      };
    case DELETE_PUBLIC_KEY_ACTIVE_LIST_CRYPTO_FAILED:
      return {
        ...state,
      };
    case DELETE_PUBLIC_KEY_ACTIVE_LIST_CRYPTO_SUCCEED:
      return {
        ...state,
      };
    case ADD_PUBLIC_KEY_TO_ACTIVE_LIST_CRYPTO_FAILED:
      return {
        ...state,
      };
    case ADD_PUBLIC_KEY_TO_ACTIVE_LIST_CRYPTO_SUCCEED:
      return {
        ...state,
      };
    default:
      return {
        ...state,
      };
  }
};
